import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ExpertCard } from '../components/ExpertCard';
import { CTASection } from '../components/CTASection';
import { Search } from 'lucide-react';
import { experts } from '../components/expertsData';
export function PanelExpertsPage() {
  useEffect(() => {
    document.title = 'Expert Medical Panel | GMC-Registered Specialists | UK Medicolegal Assessment';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', 'Browse our panel of 1,000+ GMC-registered medical experts. Consultant psychiatrists, orthopaedic surgeons, ENT specialists, and GPs available UK-wide for medico-legal assessments.');
    setMeta('robots', 'index, follow');
  }, []);
  return <div className="min-h-screen bg-warm-50" data-id="element-895">
      <Navigation data-id="element-896" />

      <main className="pt-24 pb-20" data-id="element-897">
        {/* Header Section */}
        <section className="bg-cta-500 text-white py-16 md:py-24 mb-12" data-id="element-898">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 text-center" data-id="element-899">
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] font-bold mb-6 tracking-tight" data-id="element-900">
              Our Expert Panel
            </h1>
            <p className="text-lg text-blue-100 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-901">
              Access over 1,000 GMC-registered medical experts across the UK.
              All experts vetted for qualifications, experience, and
              professional indemnity insurance. CPR Part 35 trained.
            </p>

            {/* Search Placeholder */}
            <div className="max-w-xl mx-auto relative" data-id="element-902">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-903">
                <Search className="h-5 w-5 text-ink-400" data-id="element-904" />
              </div>
              <input type="text" className="input-field pl-12 shadow-lg" placeholder="Search by specialty, name, or location..." data-id="element-905" />
            </div>
          </div>
        </section>

        {/* Experts Grid - 4 columns desktop, 2 tablet, 1 mobile */}
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-906">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-907">
            {experts.map(expert => <ExpertCard key={expert.id} expert={expert} data-id="element-908" />)}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 mt-20" data-id="element-909">
          <div className="card text-center" data-id="element-910">
            <h2 className="text-2xl md:text-3xl font-bold text-ink-900 mb-4 tracking-tight" data-id="element-911">
              Can't find the right expert?
            </h2>
            <p className="text-ink-500 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-912">
              This is just a small selection of our panel. We have access to
              specialists in every field of medicine across the UK. Contact our
              team to discuss your specific requirements.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-913">
              <a href="/contact" className="btn-primary" data-id="element-914">
                Contact Our Team
              </a>
              <a href="mailto:info@uk-medicolegal-assessment.com?subject=New%20Website%20Enquiry" className="btn-secondary" data-id="element-915">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </main>

      <CTASection data-id="element-916" />
      <Footer data-id="element-917" />
    </div>;
}